import { formatMessage } from 'devextreme/localization';
import { UserRoleAdministrator, UserRoleEditor, UserRoleOwner, UserRoleViewer } from '../../classes/consts/UserRole';

export interface UserRoleItem {
    Id: number;
    Name: string;
}

export class UserRolesHelper {
    static getUserRoles(): UserRoleItem[] {
        return [
            { Id: UserRoleViewer, Name: formatMessage("SettingsUserGrid_Viewer") },
            { Id: UserRoleEditor, Name: formatMessage("SettingsUserGrid_Editor") },
            { Id: UserRoleAdministrator, Name: formatMessage("SettingsUserGrid_Administrator") },
            { Id: UserRoleOwner, Name: formatMessage("SettingsUserGrid_Owner") }
        ];
    }

    static getRoleNameById(id: number): string {
        const role = this.getUserRoles().find(r => r.Id === id);
        return role ? role.Name : "???";
    }
}
